import './bootstrap';
import tinymce from 'tinymce';
import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();

tinymce.init({
    selector: 'textarea#myeditorinstance',
    height: 800,
    menubar: 'edit insert format',
    plugins: 'image table lists link media',
    relative_urls: false,
    toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright | indent outdent | bullist numlist | code | table | image link',
    toolbar_sticky: true,
    promotion: false,
    file_picker_callback: (callback, value, meta) => {
        let x = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        let y = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;

        let cmsURL = '/laravel-filemanager?editor=' + meta.fieldname;
        if (meta.filetype == 'image') {
            cmsURL = cmsURL + "&type=Images";
        } else {
            cmsURL = cmsURL + "&type=Files";
        }

        tinymce.activeEditor.windowManager.openUrl({
            url: cmsURL,
            title: 'Filemanager',
            width: x * 0.8,
            height: y * 0.8,
            resizable: "yes",
            close_previous: "no",
            onMessage: (api, message) => {
                callback(message.content);
            }
        });
    },
});

tinymce.init({
    selector: '.question',
    external_plugins: {
        tiny_mce_wiris: 'plugins/mathtype/plugin.min.js',
    }, extended_valid_elements: '*[.*]',
    height: 400,
    menubar: 'edit insert format',
    plugins: 'image table lists',
    relative_urls: false,
    toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright | indent outdent | bullist numlist | code | table | tiny_mce_wiris_formulaEditor image',
    toolbar_sticky: true,
    promotion: false,
    file_picker_callback: (callback, value, meta) => {
        let x = window.innerWidth || document.documentElement.clientWidth || document.getElementsByTagName('body')[0].clientWidth;
        let y = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;

        let cmsURL = '/laravel-filemanager?editor=' + meta.fieldname;
        if (meta.filetype == 'image') {
            cmsURL = cmsURL + "&type=Images";
        } else {
            cmsURL = cmsURL + "&type=Files";
        }

        tinymce.activeEditor.windowManager.openUrl({
            url: cmsURL,
            title: 'Filemanager',
            width: x * 0.8,
            height: y * 0.8,
            resizable: "yes",
            close_previous: "no",
            onMessage: (api, message) => {
                callback(message.content);
            }
        });

        // /* Provide file and text for the link dialog */
        // if (meta.filetype === 'file') {
        //     callback('https://www.google.com/logos/google.jpg', { text: 'My text' });
        // }

        // /* Provide image and alt text for the image dialog */
        // if (meta.filetype === 'image') {
        //     callback('https://www.google.com/logos/google.jpg', { alt: 'My alt text' });
        // }

        // /* Provide alternative source and posted for the media dialog */
        // if (meta.filetype === 'media') {
        //     callback('movie.mp4', { source2: 'alt.ogg', poster: 'https://www.google.com/logos/google.jpg' });
        // }
    },
    setup: function (editor) {
        editor.on('input change', () => {
            document.getElementById(editor.id).value = editor.getContent();
            const doc = document.getElementById(editor.id);
            openQuestions().answerQuestion(doc.getAttribute('task'), doc.getAttribute('taskable'), doc.getAttribute('question'));
        });
    },
});

tinymce.init({
    selector: '.ready-question',
    extended_valid_elements: '*[.*]',
    height: 400,
    menubar: '',
    plugins: '',
    relative_urls: false,
    toolbar: '',
    toolbar_sticky: true,
    readonly: true,
    promotion: false,
});
